import action from 'utils/actionCreators';

export const GET_DASHBOARD_REPORTS_REQUEST =
  'DASHBOARD/GET_DASHBOARD_REPORTS_REQUEST';
export const GET_DASHBOARD_REPORTS_SUCCESS =
  'DASHBOARD/GET_DASHBOARD_REPORTS_SUCCESS';
export const GET_DASHBOARD_REPORTS_FAILURE =
  'DASHBOARD/GET_DASHBOARD_REPORTS_FAILURE';

export const ADD_USER_PREFERENCE_REQUEST =
  'DASHBOARD/ADD_USER_PREFERENCE_REQUEST';
export const ADD_USER_PREFERENCE_SUCCESS =
  'DASHBOARD/ADD_USER_PREFERENCE_SUCCESS';
export const ADD_USER_PREFERENCE_FAILURE =
  'DASHBOARD/ADD_USER_PREFERENCE_FAILURE';

export const UPDATE_USER_PREFERENCE_REQUEST =
  'DASHBOARD/UPDATE_USER_PREFERENCE_REQUEST';
export const UPDATE_USER_PREFERENCE_SUCCESS =
  'DASHBOARD/UPDATE_USER_PREFERENCE_SUCCESS';
export const UPDATE_USER_PREFERENCE_FAILURE =
  'DASHBOARD/UPDATE_USER_PREFERENCE_FAILURE';

export const SET_PROJECT_BASIC_INFO = 'DASHBOARD/SET_PROJECT_BASIC_INFO';
export const SET_PROJECT_STATUS = 'DASHBOARD/SET_PROJECT_STATUS';
export const SET_CONTRACT_VALUE = 'DASHBOARD/SET_CONTRACT_VALUE';
export const SET_PROJECT_COST = 'DASHBOARD/SET_PROJECT_COST';
export const SET_PROJECT_VARIATIONS = 'DASHBOARD/SET_PROJECT_VARIATIONS';
export const SET_PROJECT_CASH_FLOW = 'DASHBOARD/SET_PROJECT_CASH_FLOW';
export const SET_PROJECT_REVENUE = 'DASHBOARD/SET_PROJECT_REVENUE';
export const SET_USER_PREFERENCE = 'DASHBOARD/SET_USER_PREFERENCE';
export const SET_BUDGET_STATUS = 'DASHBOARD/SET_BUDGET_STATUS';
export const SET_BUDGET_TOTAL = 'DASHBOARD/SET_BUDGET_TOTAL';

export const ADD_WIDGET = 'DASHBOARD/ADD_WIDGET';
export const REMOVE_WIDGET = 'DASHBOARD/REMOVE_WIDGET';
export const CHANGE_LAYOUT = 'DASHBOARD/CHANGE_LAYOUT';
export const OPEN_WIDGETS_MODAL = 'DASHBOARD/OPEN_WIDGETS_MODAL';
export const CLOSE_WIDGETS_MODAL = 'DASHBOARD/CLOSE_WIDGETS_MODAL';
export const OPEN_FILTER_MODAL = 'DASHBOARD/OPEN_FILTER_MODAL';
export const CLOSE_FILTER_MODAL = 'DASHBOARD/CLOSE_FILTER_MODAL';
export const SELECT_CHART = 'DASHBOARD/SELECT_CHART';
export const SELECT_WIDGET_FIELD = 'DASHBOARD/SELECT_WIDGET_FIELD';
export const FILTER_WIDGET_BY_DATE = 'DASHBOARD/FILTER_WIDGET_BY_DATE';

export const getDashboardReportsRequest = action(
  GET_DASHBOARD_REPORTS_REQUEST,
  'payload',
);

export const addUserPreferenceRequest = action(
  ADD_USER_PREFERENCE_REQUEST,
  'payload',
);

export const updateUserPreferenceRequest = action(
  UPDATE_USER_PREFERENCE_REQUEST,
  'payload',
);

export const setProjectBasicInfo = action(SET_PROJECT_BASIC_INFO, 'payload');
export const setProjectStatus = action(SET_PROJECT_STATUS, 'payload');
export const setBudgetStatus = action(SET_BUDGET_STATUS, 'payload');
export const setContractValue = action(SET_CONTRACT_VALUE, 'payload');
export const setProjectCost = action(SET_PROJECT_COST, 'payload');
export const setProjectVariations = action(SET_PROJECT_VARIATIONS, 'payload');
export const setProjectCashFlow = action(SET_PROJECT_CASH_FLOW, 'payload');
export const setProjectRevenue = action(SET_PROJECT_REVENUE, 'payload');
export const setUserPreference = action(SET_USER_PREFERENCE, 'payload');
export const addWidget = action(ADD_WIDGET, 'payload');
export const removeWidget = action(REMOVE_WIDGET, 'payload');
export const changeLayout = action(CHANGE_LAYOUT, 'payload');
export const openWidgetsModal = action(OPEN_WIDGETS_MODAL);
export const closeWidgetsModal = action(CLOSE_WIDGETS_MODAL);
export const openFilterModal = action(OPEN_FILTER_MODAL, 'payload');
export const closeFilterModal = action(CLOSE_FILTER_MODAL);
export const selectChart = action(SELECT_CHART, 'payload');
export const selectWidgetField = action(SELECT_WIDGET_FIELD, 'payload');
export const filterWidgetsByDate = action(FILTER_WIDGET_BY_DATE, 'payload');
